import { render } from "./ViewsProductsProduct.vue?vue&type=template&id=2f739c8c"
import script from "./ViewsProductsProduct.vue?vue&type=script&lang=js"
export * from "./ViewsProductsProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__